<script>
import { timestampToFormattedLocalTime } from './../../helpers/datetime.js';

import LayerTile from './LayerTile.svelte';
import { beforeUpdate, afterUpdate, createEventDispatcher, onMount } from 'svelte';

const dispatch = createEventDispatcher();

export let x;
export let y;
export let z;
export let i;
export let visible;
export let time;

export let layer;
export let opacity;
export let blend;
export let style;

export let width;
export let height;

let coord = [];

function buildId(column, row, z, h, w) {
    return `${column}-${row}-${z}-${h}-${w}`
}

function exists(column, row, z, h, w) {
    const id = buildId(column, row, z, h, w);
    return coord.filter(t => t.id === id).length > 0;
}

function updateTileCoordinates() {
    const factor = 2;
    const h = factor*height;
    const w = factor*width;

    let lc = Math.floor(Math.abs(x/width));
    while (lc % factor !== 0) lc -= 1;
    let lr = Math.floor(Math.abs(y/height));
    while (lr % factor !== 0) lr -= 1;
    if (!exists(lc, lr, z, h, w)) {
        coord.push(
            {
                id: buildId(lc, lr, z, h, w),
                r: lr,
                c: lc,
                h: h,
                w: w
            }
        );
    }
    
    if (!exists(lc+factor, lr, z, h, w)) {
        coord.push(
            {
                id: buildId(lc+factor, lr, z, h, w),
                r: lr,
                c: lc+factor,
                h: h,
                w: w
            }
        );
    }

    // check if rest of tiles "fit" in frame... if not, then save two http requests
    const bbox = map.getBoundingClientRect();
    const extraLowerRow = (lr+factor)*256;
    if (!(extraLowerRow < (y*-1)+bbox.height && extraLowerRow > (y*-1))) {
        return
    }

    if (!exists(lc, lr+factor, z, h, w)) {
            coord.push(
                {
                    id: buildId(lc, lr+factor, z, h, w),
                    r: lr+factor,
                    c: lc,
                    h: h,
                    w: w
                }
            );
        }
        if (!exists(lc+factor, lr+factor, z, h, w)) {
            coord.push(
                {
                    id: buildId(lc+factor, lr+factor, z, h, w),
                    r: lr+factor,
                    c: lc+factor,
                    h: h,
                    w: w
                }
            );
        }
}

beforeUpdate(async () => {
    updateTileCoordinates();
});

</script>
<style>
.frame-container {
    width: 880px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 1;
}
@media only screen and (max-device-width : 1024px) {
  .frame-container {
    width: 100%;
    height: 424px;
  }
}
.hidden {
    visibility: hidden;
    opacity: 0;
}
span {
    position: absolute;
    z-index: 2;
    background: #fff;
    padding: 0 3px 3px 3px;
    margin: 5px;
}
</style>

<span class="{visible ? "":"hidden"}">{timestampToFormattedLocalTime(time)}</span>

<div class="frame-container {visible ? "":"hidden"}" style="{blend ? "mix-blend-mode: " + blend + ";": ""}{opacity ? "opacity: " + opacity + ";": ""}" 
    data-frame-order="{i}">
    <div style="transform: translate3d({x}px, {y}px, 0px) scale(1);">
        {#each coord as coo (coo.id)}
            <LayerTile layer={layer} 
                row={coo.r} 
                column={coo.c} 
                time={time} 
                z={z} 
                style={style}
                width={coo.w} 
                height={coo.h} />
            {/each}
    </div>
</div>
